import styled from "styled-components";

import { toRem } from "utils/mixins";

export const Wrapper = styled.div`
  margin-bottom: ${toRem(70)};
  margin-top: ${toRem(40)};
`;
